import { useEffect, useRef, useState } from 'react';

import { Button } from '@vkontakte/vkui';
import { AnimatePresence, motion } from 'framer-motion';
import { useSelector } from 'react-redux';

import { VARIANTS } from './constants';
import  styles  from './HorizontalSlides.module.css';
import { HorizontalSlidesProps } from './types';
import { selectIsDesktop } from '../../store/settingsSlice/settingsSelectors';

export const HorizontalSlides: React.FC<HorizontalSlidesProps> = ({ pagesOptions, swapPage, page }) => {
  const isDesktop = useSelector(selectIsDesktop);

  const onClick = () => {
    if (pagesOptions[page].button.onClick != undefined){
      pagesOptions[page].button.onClick?.();
      return;
    }

    swapPage(1);
  };

  const ref = useRef(null);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    if (ref !== null) {
      //@ts-ignore
      setHeight(ref.current.offsetHeight);
      //@ts-ignore
      setWidth(ref.current.offsetWidth);
    }
  }, [ref]);

  return (
    <div style={{ height: height }}>
      <AnimatePresence initial={false}>
        <motion.div
          className={styles.slide}
          key={page}
          variants={VARIANTS}
          initial='enter'
          animate='center'
          exit='exit'
        >
          <div ref={ref} style={{ width: window.innerWidth - (isDesktop ? 132 : 40) }}>
            <div>
              {pagesOptions[page].page}
            </div>
            { pagesOptions.length > 1 && <div className={styles.button}>
              <div style={{ padding: '0 13px' }}>
                <Button
                  onClick={onClick}
                  mode={pagesOptions[page].button.mode}
                  size='l'
                  stretched
                >
                  {pagesOptions[page].button.text}
                </Button>
              </div>
            </div>}
          </div>
        </motion.div>
      </AnimatePresence> 
    </div>    
  );
};
